import ConfigAPI from "../api/ConfigAPI";
import WorkflowAPI from "../api/WorkflowAPI";
import _ from "lodash";

const WorkFlowMenuAPI = {
  menuData: [],
  isLoading: false,
  pendingPromise: null,

  all: async function() {
    let menuData = sessionStorage.getItem("menuData");

    if (menuData) {
      return JSON.parse(menuData);
    } else {
      let user = JSON.parse(sessionStorage.getItem("loggedInUser"));

      let menuData = this.menuData;
      await ConfigAPI.getConfig().then(data => {
        menuData = data.menuData;

        menuData = menuData.filter(function(el) {
          return user.workflowList.some(
            item => item.workflow.workflowId === el.workFlowId
          );
        });
      });

      menuData.forEach((menu, index) => {
        let workflow = _.find(user.workflowList, {
          workflow: {
            workflowId: menu.workFlowId
          }
        });
        let exercises = workflow.exercises
          .map(exercise => exercise.code)
          .join(",");
        menu.exerciseId = exercises;
      });

      sessionStorage.setItem("menuData", JSON.stringify(menuData));
      return menuData;
    }
  },

  updatedList: async function() {

    // If there's a pending request, return its promise
    if (this.pendingPromise) {
      return this.pendingPromise;
    }

    let menuData = sessionStorage.getItem("menuData");

    if (menuData) {
      return JSON.parse(menuData);
    } else {
      this.isLoading = true;

      // Create a new promise for this request
      this.pendingPromise = (async () => {
        try {
          let user = JSON.parse(sessionStorage.getItem("loggedInUser"));
          let menuData = this.menuData;

          await WorkflowAPI.all().then(data => {
            menuData = data.data;
            menuData = menuData.filter(function(el) {
              return user.workflowList.some(
                  item => item.workflow.workflowId === el.workflowId
              );
            });
          });

      menuData.forEach((menu, index) => {
        let workflow = _.find(user.workflowList, {
          workflow: {
            workflowId: menu.workflowId
          }
        });

            let exercises = workflow.exercises
                .map(exercise => exercise.code)
                .join(",");
            menu.exerciseId = exercises;
          });

          sessionStorage.setItem("menuData", JSON.stringify(menuData));
          return menuData;
        } finally {
          this.isLoading = false;
          this.pendingPromise = null;
        }
      })();

      return this.pendingPromise;
    }
  },

  reinitialize: async function() {

    // If there's already a request in progress, wait for it and return its result
    if (this.pendingPromise) {
      return this.pendingPromise;
    }

    // Clear the cache
    sessionStorage.removeItem("menuData");
    // Reset loading flag and pending promise
    this.isLoading = false;
    this.pendingPromise = null;
    // Get fresh data
    return await this.updatedList();
  }
};

export default WorkFlowMenuAPI;
